const SUBMITTED_PREFIX_RE = /^\s*submitted code(?:\s*\(([^)]*)\))?\s*:?\s*\n?/i;
/**
 * Extract the code block from a transcript entry, or null when the entry is
 * ordinary prose (so callers keep their existing rendering untouched).
 *
 * @param text        the transcript text as stored/sent
 * @param codeSnippet the separately-carried source, when the surface has it
 */
export const parseSubmittedCode = (text, codeSnippet) => {
    var _a;
    const raw = typeof text === 'string' ? text : '';
    const snippet = typeof codeSnippet === 'string' ? codeSnippet : '';
    const match = SUBMITTED_PREFIX_RE.exec(raw);
    const language = ((_a = match === null || match === void 0 ? void 0 : match[1]) === null || _a === void 0 ? void 0 : _a.trim().toLowerCase()) || null;
    // Prefer the explicit snippet: it is the exact source the candidate submitted,
    // untouched by any transcript formatting.
    if (snippet.trim()) {
        // The transcript usually embeds the snippet after the prefix; whatever is
        // left once the prefix and the code are removed is the label.
        const label = raw
            .replace(snippet, '')
            .replace(/:\s*$/, '')
            .trim() || 'Submitted code';
        return { label, language, code: snippet.replace(/\s+$/, '') };
    }
    if (!match)
        return null;
    const body = raw.slice(match[0].length).replace(/\s+$/, '');
    if (!body.trim())
        return null; // "Submitted code (python):" with nothing after it
    return {
        label: match[0].replace(/:\s*\n?\s*$/, '').trim() || 'Submitted code',
        language,
        code: body,
    };
};
/** True when the entry should render as a code block. */
export const hasSubmittedCode = (text, codeSnippet) => parseSubmittedCode(text, codeSnippet) !== null;
